import { Component, OnInit } from "@angular/core";
import { faPencil, faBroom } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { AmendChequePurposeService } from "src/app/services/autopac/amend-cheque-purpose.service";
import { NotifierService } from "angular-notifier";

interface accoundCode {
  Description: string;
  Name: string;
  Status: boolean;
  Value: string;
  __type: string;
}

@Component({
  selector: "app-amend-cheque-purpose",
  templateUrl: "./amend-cheque-purpose.component.html",
  styleUrls: ["./amend-cheque-purpose.component.css"],
})
export class AmendChequePurposeComponent implements OnInit {
  faPencil = faPencil;
  faBroom = faBroom;

  lockUpdate: boolean = true;

  form: FormField[] = [
    {
      type: "search",
      id: "chequeNumber",
      label: "Cheque number",
      required: true,
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "text",
      id: "oldPurpose",
      label: "Old purpose",
      lock: true,
    },
    {
      type: "select",
      id: "newPurpose",
      label: "New purpose",
      required: true,
    },
  ];

  constructor(
    private amendChequePurposeService: AmendChequePurposeService,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {
    this.amendChequePurposeService.GetAllAccountCode().subscribe({
      next: (response) => {
        this.getField("newPurpose").options = response.body.map(
          (item: accoundCode) => ({
            display: item.Name,
            value: item.Name,
          }),
        );
      },
      error: (error) => console.log(error),
    });
  }

  search(): void {
    const chequeNumber = this.getField("chequeNumber").value;
    if (!chequeNumber) return;

    this.amendChequePurposeService
      .AmmendChequePurposeService(chequeNumber)
      .subscribe({
        next: (response) => {
          if (response.code === -1) {
            this.notifier.notify("error", response.message);
            this.getField("chequeNumber").value = undefined;
          } else {
            this.lockUpdate = false;
            this.getField("oldPurpose").value = response.body;
          }
        },
        error: (error) => console.log(error),
      });
  }

  update(): void {
    const chequeNumber = this.getField("chequeNumber").value;
    const purpose = this.getField("newPurpose").value;

    if (!purpose) {
      this.notifier.notify("error", "Plase select a new purpose");
      return;
    }

    this.amendChequePurposeService
      .UpdatePurpose(chequeNumber, purpose)
      .subscribe({
        next: () => {
          this.notifier.notify(
            "success",
            "Cheque purpose has been updated successfully",
          );
        },
        error: (error) => console.log(error),
      });
  }

  clear(): void {
    for (const field of this.form) {
      this.getField(field.id).value = undefined;
    }
    this.lockUpdate = true;
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
